import { TApplicationState } from '../../types/redux';

export const selectNewbuildingSeoBlock = (state: TApplicationState) => {
  return state.newbuildingsSeoBlock;
};
